import axios from '@fs/zion-axios'
import { i18n } from '@fs/zion-locale'
import { getMostRecentFieldValue } from '@fs/zion-sls'
import { SG_BASE_URL, headers } from '../config'

export async function getPersonLocalizedFullName(person) {
  const name = person.subElements?.find((se) => se.elementType === 'NAME')
  if (name) {
    const query = new URLSearchParams()
    if (name.subElements) {
      name.subElements.forEach((se) => {
        if (se.subElements) {
          se.subElements.forEach((field) => {
            const fieldValue = getMostRecentFieldValue(field)
            if (fieldValue) {
              switch (field.fieldType) {
                case 'NAME_GN':
                  query.set('given', fieldValue)
                  break
                case 'NAME_SURN':
                  query.set('surname', fieldValue)
                  break
                case 'NAME_SUF':
                  query.set('suffix', fieldValue)
                  break
                case 'NAME_PRE':
                  query.set('prefix', fieldValue)
                  break
                default:
                  break
              }
            }
          })
        }
      })
    }
    if (query.has('given') || query.has('surname') || query.has('suffix') || query.has('prefix')) {
      const lang = i18n.language
      query.set('lang', lang)
      query.set('targetLang', lang)

      const response = await axios.get(`${SG_BASE_URL}/service/standards/name-seg/ws/names?${query.toString()}`, {
        headers,
      })
      return response.data.names[0].fullname
    }
  }
  return null
}

export default async function getPersonFullNameFromStandards(person) {
  const localizedName = await getPersonLocalizedFullName(person)
  return {
    id: person.id,
    localizedName,
  }
}

export async function getBulkStandardizedFullNames(persons) {
  if (!persons || persons.length === 0) return []
  const lang = i18n.language
  const requestData = persons
    .map((person) => {
      const name = person.subElements?.find((se) => se.elementType === 'NAME')
      const parts = {}
      if (name) {
        const fieldTypeToParts = { NAME_GN: 'given', NAME_SURN: 'surname', NAME_SUF: 'suffix', NAME_PRE: 'prefix' }
        if (name.subElements) {
          name.subElements.forEach((se) => {
            if (se.subElements) {
              se.subElements.forEach((field) => {
                parts[fieldTypeToParts[field.fieldType]] = getMostRecentFieldValue(field) || ''
              })
            }
          })
        }
      }
      return {
        id: person.id,
        parts,
        lang,
        targetLang: lang,
        annotations: [],
      }
    })
    .filter((name) => name.parts.given || name.parts.surname || name.parts.suffix || name.parts.prefix)

  const response = await axios.post(
    `${SG_BASE_URL}/service/standards/name-seg/ws/names`,
    { names: requestData },
    { headers }
  )
  return response.data.names.map((name) => ({ id: name.id, localizedName: name.fullname }))
}
